import styled, { css } from 'styled-components';
import { PlayHeading } from './PlayHeading.styles';
import { playFontSize } from './helpers';
import { fontWeightRegular, regularWhite } from '../design-tokens';
import { device } from '../breakpoints';

export const PlayListHeading = styled(PlayHeading)`
    ${playFontSize(1.8, true)};
    font-weight: ${fontWeightRegular};
    color: ${regularWhite};
    line-height: 1.3;

    @media ${device.GteSmall} {
        ${playFontSize(2)}
    }
`;

export const PlayListHeaderPadding = css`
    padding: 10px 10px 15px 0;

    @media ${device.GteSmall} {
        padding-bottom: 13px;
    }

    @media ${device.GteMedium} {
        padding-bottom: 18px;
    }
`;
